import { HttpClient } from '@adapters/HttpClient';

export interface User {
    id: number;
    name: string;
    email: string;
}

export class UsersApiAdapter {
    constructor(private httpClient: HttpClient) { }

    async getAll(): Promise<User[]> {
        const response = await this.httpClient.get<User[]>('/users');
        return Array.isArray(response) ? response : [];
    }
}

